import React from "react";
import * as OrderFunctions from "../../../reservations/components/behaviors/OrderFunctions";
import {moment} from "../../../../../../vendor";
import {dateFormat, timeFormat} from "../../../../../utils/FormatHelper";
import t from "../../../../helpers/t";

const ReservationSelect = (props) => {
    const {reservations, setReservation, language} = props;
    const onChangeReservation = (reservation,e) => {
        setReservation(reservation);
    }
    return (
        <>

                {reservations.length < 1 ?<><div className="inb-c-item inb-c-item--from row" key="noid">
                    <div className="small-12 medium-12 column" style={{textAlign:"center"}}>
                        {t('no orders found.')}
                    </div> </div> </>:
                    reservations.map(reservation=> {
                    let endReserv = (reservation.end !== null && moment(reservation.end).format(dateFormat(language)) !== moment(reservation.begin).format(dateFormat(language)));
                        return (
                            <>
                                <div className="inb-c-item inb-c-item--from row" key={reservation.id}>
                                    <div className="small-6 medium-1 column" key={"ordernbr_" + reservation.id}>
                                        {reservation?.order?.order_nbr}
                                    </div>
                                    <div className="small-6 medium-4 column" key={"name_" + reservation.id}>
                                        {moment(reservation.begin).format(dateFormat(language, true))} {moment(reservation.begin).format(timeFormat(language))} - {endReserv ? moment(reservation.begin).format(dateFormat(language, true)) : ""} {moment(reservation.end).format(timeFormat(language))}
                                    </div>
                                    <div className="small-3 medium-3 column" key={"user_" + reservation.id}>
                                        {OrderFunctions.getOrderUsername(reservation?.order)}
                                    </div>
                                    <div className="small-6 medium-2 column" key={"status_" + reservation.id}>
                                        {t(reservation.status, null, 'capital')}
                                    </div>
                                    <div className="small-6 medium-2 column" key={"button_" + reservation.id}>
                                        <input className="button beautify" style={{marginTop: "5px"}} type="button"
                                               onClick={e => onChangeReservation(reservation, e)} value="Auswählen"/>
                                    </div>
                                </div>
                            </>
                        );

                })}
        </>
    )
};
export default ReservationSelect;